import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { sendSearchClick } from 'src/utils/analytics';
import { checkRadius } from 'src/redux/actions/searchParams';
import FormSend from 'src/components/Search/FormSend';


const workplaceChanged = (previousProperties, nextProperties) => {
  const valueChanged = previousProperties.value !== nextProperties.value;
  const chipsChanged = JSON.stringify(previousProperties.tokens) !== JSON.stringify(nextProperties.tokens);

  return valueChanged || chipsChanged;
};

class FormSendContainer extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.checkRadius();
  }

  componentDidUpdate(previousProperties) {
    const { actions, searchParams } = this.props;
    if (workplaceChanged(previousProperties.searchParams.autocomplete.workplace, searchParams.autocomplete.workplace)) {
      actions.checkRadius();
    }
  }

  render() {
    const { searchParams, analytics } = this.props;

    const analyticsActions = {
      sendSearchClick: () => {
        analytics.sendSearchClick(searchParams);
      }
    };

    return (
      <React.Fragment>
        <FormSend analyticsActions={ analyticsActions } />
      </React.Fragment>
    );
  }
}

FormSendContainer.propTypes = {
  actions: PropTypes.shape({
    checkRadius: PropTypes.func
  }),
  analytics: PropTypes.shape({
    sendSearchClick: PropTypes.func
  }),
  searchParams: PropTypes.shape({
    autocomplete: PropTypes.shape({
      keyword: PropTypes.shape({
        latest: PropTypes.array,
        suggestions: PropTypes.array,
        tokens: PropTypes.array,
        value: PropTypes.string
      }),
      workplace: PropTypes.shape({
        latest: PropTypes.array,
        suggestions: PropTypes.array,
        tokens: PropTypes.array,
        value: PropTypes.string
      })
    }),
    current: PropTypes.shape({
      countries: PropTypes.array,
      employers: PropTypes.array,
      keyword: PropTypes.array,
      radius: PropTypes.number,
      radiusDisabled: PropTypes.bool,
      regions: PropTypes.array,
      skills: PropTypes.array,
      workplace: PropTypes.array
    })
  })
};

FormSendContainer.defaultProps = {
  actions: {
    checkRadius: () => {
    }
  },
  analytics: {
    sendSearchClick: () => {
    }
  },
  searchParams: {}
};

const mapStateToProperties = state => (
  {
    searchParams: state.searchParamsReducer
  }
);

const mapDispatchToProperties = dispatch => (
  {
    analytics: {
      sendSearchClick
    },
    actions: {
      checkRadius: () => dispatch(checkRadius())
    }
  }
);

export default connect(mapStateToProperties, mapDispatchToProperties)(FormSendContainer);
